import { makeTable } from "../utils/tables";
import random from "lodash/random";

export const startingKits = makeTable("startingKits", [
  {
    name: "PROSPECTOR",
    description:
      "Handheld material analyzer, magnetic boots, breathing mask (1 use), container with engine grease",
  },
  {
    name: "RING THUG",
    description:
      "Distillery kit, lockpicks, holographic playing cards, {doses, plural, one {one dose of some unknown substances} other {# doses of unknown substances}} mixed in a bag",
    getValues: () => ({ doses: random(1, 4) }),
  },
  {
    name: "MERCENARY",
    description:
      "Uniform, planetary parachute, proximity alarm (needs batteries), flashlight model P78C",
  },
  {
    name: "NOMAD",
    description:
      "Liquid purifier (removes contaminants), hover hammock, box of spices, pack of incense sticks, rechargeable battery with compact solar panel",
  },
  {
    name: "ENGINEER",
    description:
      "Electric multi-tool, duct tape, tablet computer (plug in for network access), fusion welder, workwear",
  },
  {
    name: "EXPLORER",
    description:
      "Emergency food rations (1 week), light EVA suit, 5 military grade light sticks, tent for extreme weather",
  },
]);
